import axios from "axios";
import Config from "../Config";
import ErrorMessage from "../libs/helpers/ErrorMessage";
import { getFromLocalStorage } from "../libs/helpers/localstorage";
import { buildFetchOptions, buildAxiosConfig } from "./utils";

export const getPitchEntityApi = async ({ headers, page }) => {
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.pitch.list}/entity`,
    buildFetchOptions("GET", null, headers),
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  } else {
    const { statusText, status } = res;
    const { httpStatus, clientType, description } = response;
    throw new ErrorMessage(
      statusText,
      description,
      httpStatus,
      status,
      clientType,
    );
  }
};
//

export const getPitchDetailApi = async ({ headers, id }) => {
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.pitch.list}/${id}`,
    buildFetchOptions("GET", null, headers),
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  } else {
    const { statusText, status } = res;
    const { httpStatus, clientType, description } = response;
    throw new ErrorMessage(
      statusText,
      description,
      httpStatus,
      status,
      clientType,
    );
  }
};

export const editPitchDetailApi = async ({ headers, id, data }) => {
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.pitch.detail}/${id}`,
    buildFetchOptions("PUT", data, headers),
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  } else {
    const { statusText, status } = res;
    const { httpStatus, clientType, description } = response;
    throw new ErrorMessage(
      statusText,
      description,
      httpStatus,
      status,
      clientType,
    );
  }
};

export const getPitchScoresApi = async ({ headers, data = {} }) => {
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/api/v1/pitch/scores`,
      data,
      buildAxiosConfig(headers),
    );

    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    } else throw e;
  }
};

export const editPitchScoreApi = async ({ headers, data = {}, id }) => {
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/api/v1/pitch/scores/${id}`,
      data,
      buildAxiosConfig(headers),
    );

    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    } else throw e;
  }
};

export const deletePitchApi = async ({ headers, id }) => {
  try {
    await axios.delete(
      `${Config.apiBaseurl}/${Config.apis.pitch.list}/${id}`,
      buildAxiosConfig(headers)
    );
    return true;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType
      );
    } else throw e;
  }
};
